/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  CreditCardAuthQueueResponse,
  CreditCardAuthRequestedRequest,
  CreditCardAuthRequestedResponse,
  CreditCardAuthSubmittedRequest,
  CreditCardAuthSubmittedResponse,
  EditConfirmationRequest,
  EditConfirmationResponse,
  FavoriteHotelPurgeResponse,
  FlightPaymentOperationApprovalRequest,
  FlightPaymentOperationApprovalResponse,
  FlightSupportProjectionRequest,
  FlightSupportProjectionResponse,
  GetBookingInfoRequest,
  GetBookingInfoResponse,
  InternalMCPRateWatchCreateRequest,
  InternalMCPTaskCancelRequest,
  InternalMCPTaskCreateRequest,
  InternalMCPTaskCreateResponse,
  InternalMCPTaskOwnerRequest,
  InternalMCPTaskResponse,
  InternalMCPTaskUpdateRequest,
  OperatorBookingsRequest,
  ResolveReservationRequest,
  ResolveReservationResponse,
  SetReservationNotesRequest,
  SetReservationNotesResponse,
  UnprocessedReservationsResponse,
} from '../models/index';
import {
    CreditCardAuthQueueResponseFromJSON,
    CreditCardAuthQueueResponseToJSON,
    CreditCardAuthRequestedRequestFromJSON,
    CreditCardAuthRequestedRequestToJSON,
    CreditCardAuthRequestedResponseFromJSON,
    CreditCardAuthRequestedResponseToJSON,
    CreditCardAuthSubmittedRequestFromJSON,
    CreditCardAuthSubmittedRequestToJSON,
    CreditCardAuthSubmittedResponseFromJSON,
    CreditCardAuthSubmittedResponseToJSON,
    EditConfirmationRequestFromJSON,
    EditConfirmationRequestToJSON,
    EditConfirmationResponseFromJSON,
    EditConfirmationResponseToJSON,
    FavoriteHotelPurgeResponseFromJSON,
    FavoriteHotelPurgeResponseToJSON,
    FlightPaymentOperationApprovalRequestFromJSON,
    FlightPaymentOperationApprovalRequestToJSON,
    FlightPaymentOperationApprovalResponseFromJSON,
    FlightPaymentOperationApprovalResponseToJSON,
    FlightSupportProjectionRequestFromJSON,
    FlightSupportProjectionRequestToJSON,
    FlightSupportProjectionResponseFromJSON,
    FlightSupportProjectionResponseToJSON,
    GetBookingInfoRequestFromJSON,
    GetBookingInfoRequestToJSON,
    GetBookingInfoResponseFromJSON,
    GetBookingInfoResponseToJSON,
    InternalMCPRateWatchCreateRequestFromJSON,
    InternalMCPRateWatchCreateRequestToJSON,
    InternalMCPTaskCancelRequestFromJSON,
    InternalMCPTaskCancelRequestToJSON,
    InternalMCPTaskCreateRequestFromJSON,
    InternalMCPTaskCreateRequestToJSON,
    InternalMCPTaskCreateResponseFromJSON,
    InternalMCPTaskCreateResponseToJSON,
    InternalMCPTaskOwnerRequestFromJSON,
    InternalMCPTaskOwnerRequestToJSON,
    InternalMCPTaskResponseFromJSON,
    InternalMCPTaskResponseToJSON,
    InternalMCPTaskUpdateRequestFromJSON,
    InternalMCPTaskUpdateRequestToJSON,
    OperatorBookingsRequestFromJSON,
    OperatorBookingsRequestToJSON,
    ResolveReservationRequestFromJSON,
    ResolveReservationRequestToJSON,
    ResolveReservationResponseFromJSON,
    ResolveReservationResponseToJSON,
    SetReservationNotesRequestFromJSON,
    SetReservationNotesRequestToJSON,
    SetReservationNotesResponseFromJSON,
    SetReservationNotesResponseToJSON,
    UnprocessedReservationsResponseFromJSON,
    UnprocessedReservationsResponseToJSON,
} from '../models/index';

export interface V2InternalFlightsBookingsSupportProjectionPostRequest {
    flightSupportProjectionRequest: FlightSupportProjectionRequest;
}

export interface V2InternalFlightsPaymentOperationsApprovePostRequest {
    flightPaymentOperationApprovalRequest: FlightPaymentOperationApprovalRequest;
}

export interface V2InternalMcpRateWatchesPostRequest {
    internalMCPRateWatchCreateRequest: InternalMCPRateWatchCreateRequest;
}

export interface V2InternalMcpTasksPostRequest {
    internalMCPTaskCreateRequest: InternalMCPTaskCreateRequest;
}

export interface V2InternalMcpTasksTaskIdCancelPostRequest {
    taskId: string;
    internalMCPTaskCancelRequest: InternalMCPTaskCancelRequest;
}

export interface V2InternalMcpTasksTaskIdGetPostRequest {
    taskId: string;
    internalMCPTaskOwnerRequest: InternalMCPTaskOwnerRequest;
}

export interface V2InternalMcpTasksTaskIdUpdatePostRequest {
    taskId: string;
    internalMCPTaskUpdateRequest: InternalMCPTaskUpdateRequest;
}

export interface V2InternalReservationsBookingInfoPostRequest {
    getBookingInfoRequest: GetBookingInfoRequest;
}

export interface V2InternalReservationsByOperatorPostRequest {
    operatorBookingsRequest: OperatorBookingsRequest;
}

export interface V2InternalReservationsConfirmationPostRequest {
    editConfirmationRequest: EditConfirmationRequest;
}

export interface V2InternalReservationsCreditCardAuthQueueGetRequest {
    daysAhead?: number;
    includeSubmitted?: boolean;
}

export interface V2InternalReservationsCreditCardAuthRequestedPostRequest {
    creditCardAuthRequestedRequest: CreditCardAuthRequestedRequest;
}

export interface V2InternalReservationsCreditCardAuthSubmittedPostRequest {
    creditCardAuthSubmittedRequest: CreditCardAuthSubmittedRequest;
}

export interface V2InternalReservationsNotesPostRequest {
    setReservationNotesRequest: SetReservationNotesRequest;
}

export interface V2InternalReservationsResolvePostRequest {
    resolveReservationRequest: ResolveReservationRequest;
}

export interface V2InternalUsersUserIdFavoriteHotelsDeleteRequest {
    userId: string;
}

/**
 *
 */
export class InternalApi extends runtime.BaseAPI {

    /**
     * Return a bounded, privacy-reduced projection of one authoritative Search flight booking. The canonical identity is the owner-scoped pair `(user_id, booking_id)`. Malformed, foreign, and missing booking IDs are intentionally indistinguishable. Chronology is ordered by `(created_at, id)` and paged with a client-opaque cursor. This endpoint never calls a supplier or payment system and never mutates booking or recovery state. Requires the `service:api_support` principal in addition to OAuth authentication.
     */
    async v2InternalFlightsBookingsSupportProjectionPostRaw(requestParameters: V2InternalFlightsBookingsSupportProjectionPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FlightSupportProjectionResponse>> {
        if (requestParameters['flightSupportProjectionRequest'] == null) {
            throw new runtime.RequiredError(
                'flightSupportProjectionRequest',
                'Required parameter "flightSupportProjectionRequest" was null or undefined when calling v2InternalFlightsBookingsSupportProjectionPost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("common_auth", []);
        }


        let urlPath = `/v2/internal/flights/bookings/support-projection`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: FlightSupportProjectionRequestToJSON(requestParameters['flightSupportProjectionRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FlightSupportProjectionResponseFromJSON(jsonValue));
    }

    /**
     * Return a bounded, privacy-reduced projection of one authoritative Search flight booking. The canonical identity is the owner-scoped pair `(user_id, booking_id)`. Malformed, foreign, and missing booking IDs are intentionally indistinguishable. Chronology is ordered by `(created_at, id)` and paged with a client-opaque cursor. This endpoint never calls a supplier or payment system and never mutates booking or recovery state. Requires the `service:api_support` principal in addition to OAuth authentication.
     */
    async v2InternalFlightsBookingsSupportProjectionPost(requestParameters: V2InternalFlightsBookingsSupportProjectionPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FlightSupportProjectionResponse> {
        const response = await this.v2InternalFlightsBookingsSupportProjectionPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Persist one immutable approval for an existing prepared authorization release or customer refund. Requires the exact `service:api_support` principal. This endpoint performs no payment dispatch and callers must not retry with a different approval request ID.
     */
    async v2InternalFlightsPaymentOperationsApprovePostRaw(requestParameters: V2InternalFlightsPaymentOperationsApprovePostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FlightPaymentOperationApprovalResponse>> {
        if (requestParameters['flightPaymentOperationApprovalRequest'] == null) {
            throw new runtime.RequiredError(
                'flightPaymentOperationApprovalRequest',
                'Required parameter "flightPaymentOperationApprovalRequest" was null or undefined when calling v2InternalFlightsPaymentOperationsApprovePost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("common_auth", []);
        }


        let urlPath = `/v2/internal/flights/payment-operations/approve`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: FlightPaymentOperationApprovalRequestToJSON(requestParameters['flightPaymentOperationApprovalRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FlightPaymentOperationApprovalResponseFromJSON(jsonValue));
    }

    /**
     * Persist one immutable approval for an existing prepared authorization release or customer refund. Requires the exact `service:api_support` principal. This endpoint performs no payment dispatch and callers must not retry with a different approval request ID.
     */
    async v2InternalFlightsPaymentOperationsApprovePost(requestParameters: V2InternalFlightsPaymentOperationsApprovePostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FlightPaymentOperationApprovalResponse> {
        const response = await this.v2InternalFlightsPaymentOperationsApprovePostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Atomically create an owner-scoped durable rate-watch task and its one linked specific-date rate alert. Requires the service:api_mcp principal.
     */
    async v2InternalMcpRateWatchesPostRaw(requestParameters: V2InternalMcpRateWatchesPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<InternalMCPTaskCreateResponse>> {
        if (requestParameters['internalMCPRateWatchCreateRequest'] == null) {
            throw new runtime.RequiredError(
                'internalMCPRateWatchCreateRequest',
                'Required parameter "internalMCPRateWatchCreateRequest" was null or undefined when calling v2InternalMcpRateWatchesPost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("common_auth", []);
        }


        let urlPath = `/v2/internal/mcp/rate-watches`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: InternalMCPRateWatchCreateRequestToJSON(requestParameters['internalMCPRateWatchCreateRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InternalMCPTaskCreateResponseFromJSON(jsonValue));
    }

    /**
     * Atomically create an owner-scoped durable rate-watch task and its one linked specific-date rate alert. Requires the service:api_mcp principal.
     */
    async v2InternalMcpRateWatchesPost(requestParameters: V2InternalMcpRateWatchesPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<InternalMCPTaskCreateResponse> {
        const response = await this.v2InternalMcpRateWatchesPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Idempotently create a durable generic MCP task for an asserted OAuth user/client owner. Requires the service:api_mcp principal. The task is committed before this route returns.
     */
    async v2InternalMcpTasksPostRaw(requestParameters: V2InternalMcpTasksPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<InternalMCPTaskCreateResponse>> {
        if (requestParameters['internalMCPTaskCreateRequest'] == null) {
            throw new runtime.RequiredError(
                'internalMCPTaskCreateRequest',
                'Required parameter "internalMCPTaskCreateRequest" was null or undefined when calling v2InternalMcpTasksPost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("common_auth", []);
        }


        let urlPath = `/v2/internal/mcp/tasks`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: InternalMCPTaskCreateRequestToJSON(requestParameters['internalMCPTaskCreateRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InternalMCPTaskCreateResponseFromJSON(jsonValue));
    }

    /**
     * Idempotently create a durable generic MCP task for an asserted OAuth user/client owner. Requires the service:api_mcp principal. The task is committed before this route returns.
     */
    async v2InternalMcpTasksPost(requestParameters: V2InternalMcpTasksPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<InternalMCPTaskCreateResponse> {
        const response = await this.v2InternalMcpTasksPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Atomically cancel an active owner-scoped task. Replayed cancellation is idempotent; another terminal outcome wins. Requires the service:api_mcp principal.
     */
    async v2InternalMcpTasksTaskIdCancelPostRaw(requestParameters: V2InternalMcpTasksTaskIdCancelPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<InternalMCPTaskResponse>> {
        if (requestParameters['taskId'] == null) {
            throw new runtime.RequiredError(
                'taskId',
                'Required parameter "taskId" was null or undefined when calling v2InternalMcpTasksTaskIdCancelPost().'
            );
        }

        if (requestParameters['internalMCPTaskCancelRequest'] == null) {
            throw new runtime.RequiredError(
                'internalMCPTaskCancelRequest',
                'Required parameter "internalMCPTaskCancelRequest" was null or undefined when calling v2InternalMcpTasksTaskIdCancelPost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("common_auth", []);
        }


        let urlPath = `/v2/internal/mcp/tasks/{task_id}/cancel`;
        urlPath = urlPath.replace(`{${"task_id"}}`, encodeURIComponent(String(requestParameters['taskId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: InternalMCPTaskCancelRequestToJSON(requestParameters['internalMCPTaskCancelRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InternalMCPTaskResponseFromJSON(jsonValue));
    }

    /**
     * Atomically cancel an active owner-scoped task. Replayed cancellation is idempotent; another terminal outcome wins. Requires the service:api_mcp principal.
     */
    async v2InternalMcpTasksTaskIdCancelPost(requestParameters: V2InternalMcpTasksTaskIdCancelPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<InternalMCPTaskResponse> {
        const response = await this.v2InternalMcpTasksTaskIdCancelPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get and durably record a poll for an owner-scoped MCP task. Missing, expired, and foreign-owner tasks are indistinguishable. Requires the service:api_mcp principal.
     */
    async v2InternalMcpTasksTaskIdGetPostRaw(requestParameters: V2InternalMcpTasksTaskIdGetPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<InternalMCPTaskResponse>> {
        if (requestParameters['taskId'] == null) {
            throw new runtime.RequiredError(
                'taskId',
                'Required parameter "taskId" was null or undefined when calling v2InternalMcpTasksTaskIdGetPost().'
            );
        }

        if (requestParameters['internalMCPTaskOwnerRequest'] == null) {
            throw new runtime.RequiredError(
                'internalMCPTaskOwnerRequest',
                'Required parameter "internalMCPTaskOwnerRequest" was null or undefined when calling v2InternalMcpTasksTaskIdGetPost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("common_auth", []);
        }


        let urlPath = `/v2/internal/mcp/tasks/{task_id}/get`;
        urlPath = urlPath.replace(`{${"task_id"}}`, encodeURIComponent(String(requestParameters['taskId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: InternalMCPTaskOwnerRequestToJSON(requestParameters['internalMCPTaskOwnerRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InternalMCPTaskResponseFromJSON(jsonValue));
    }

    /**
     * Get and durably record a poll for an owner-scoped MCP task. Missing, expired, and foreign-owner tasks are indistinguishable. Requires the service:api_mcp principal.
     */
    async v2InternalMcpTasksTaskIdGetPost(requestParameters: V2InternalMcpTasksTaskIdGetPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<InternalMCPTaskResponse> {
        const response = await this.v2InternalMcpTasksTaskIdGetPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Submit client input or perform an optimistic internal task transition. Terminal states never change. Requires the service:api_mcp principal.
     */
    async v2InternalMcpTasksTaskIdUpdatePostRaw(requestParameters: V2InternalMcpTasksTaskIdUpdatePostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<InternalMCPTaskResponse>> {
        if (requestParameters['taskId'] == null) {
            throw new runtime.RequiredError(
                'taskId',
                'Required parameter "taskId" was null or undefined when calling v2InternalMcpTasksTaskIdUpdatePost().'
            );
        }

        if (requestParameters['internalMCPTaskUpdateRequest'] == null) {
            throw new runtime.RequiredError(
                'internalMCPTaskUpdateRequest',
                'Required parameter "internalMCPTaskUpdateRequest" was null or undefined when calling v2InternalMcpTasksTaskIdUpdatePost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("common_auth", []);
        }


        let urlPath = `/v2/internal/mcp/tasks/{task_id}/update`;
        urlPath = urlPath.replace(`{${"task_id"}}`, encodeURIComponent(String(requestParameters['taskId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: InternalMCPTaskUpdateRequestToJSON(requestParameters['internalMCPTaskUpdateRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InternalMCPTaskResponseFromJSON(jsonValue));
    }

    /**
     * Submit client input or perform an optimistic internal task transition. Terminal states never change. Requires the service:api_mcp principal.
     */
    async v2InternalMcpTasksTaskIdUpdatePost(requestParameters: V2InternalMcpTasksTaskIdUpdatePostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<InternalMCPTaskResponse> {
        const response = await this.v2InternalMcpTasksTaskIdUpdatePostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Full booking-info field set for a numeric booking_id — everything an operator needs to complete a manual booking on a supplier\'s site (booking, rate, guest, and card *metadata*). Mirrors the direct_booking_helper CLI output. The card PAN + CVC are NOT included: they stay tokenized and only ever de-tokenize client-side in the VGS iframe. Requires a service-principal JWT.
     */
    async v2InternalReservationsBookingInfoPostRaw(requestParameters: V2InternalReservationsBookingInfoPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetBookingInfoResponse>> {
        if (requestParameters['getBookingInfoRequest'] == null) {
            throw new runtime.RequiredError(
                'getBookingInfoRequest',
                'Required parameter "getBookingInfoRequest" was null or undefined when calling v2InternalReservationsBookingInfoPost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("common_auth", []);
        }


        let urlPath = `/v2/internal/reservations/booking_info`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: GetBookingInfoRequestToJSON(requestParameters['getBookingInfoRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetBookingInfoResponseFromJSON(jsonValue));
    }

    /**
     * Full booking-info field set for a numeric booking_id — everything an operator needs to complete a manual booking on a supplier\'s site (booking, rate, guest, and card *metadata*). Mirrors the direct_booking_helper CLI output. The card PAN + CVC are NOT included: they stay tokenized and only ever de-tokenize client-side in the VGS iframe. Requires a service-principal JWT.
     */
    async v2InternalReservationsBookingInfoPost(requestParameters: V2InternalReservationsBookingInfoPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetBookingInfoResponse> {
        const response = await this.v2InternalReservationsBookingInfoPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * List the reservations a support operator has manually completed, newest first, by their Gondola user id. Powers the operator\'s my-bookings review. Requires a service-principal JWT.
     */
    async v2InternalReservationsByOperatorPostRaw(requestParameters: V2InternalReservationsByOperatorPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UnprocessedReservationsResponse>> {
        if (requestParameters['operatorBookingsRequest'] == null) {
            throw new runtime.RequiredError(
                'operatorBookingsRequest',
                'Required parameter "operatorBookingsRequest" was null or undefined when calling v2InternalReservationsByOperatorPost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("common_auth", []);
        }


        let urlPath = `/v2/internal/reservations/by-operator`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: OperatorBookingsRequestToJSON(requestParameters['operatorBookingsRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UnprocessedReservationsResponseFromJSON(jsonValue));
    }

    /**
     * List the reservations a support operator has manually completed, newest first, by their Gondola user id. Powers the operator\'s my-bookings review. Requires a service-principal JWT.
     */
    async v2InternalReservationsByOperatorPost(requestParameters: V2InternalReservationsByOperatorPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UnprocessedReservationsResponse> {
        const response = await this.v2InternalReservationsByOperatorPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Edit the confirmation (provider booking) number on a reservation, by its numeric booking_id, and re-push it to the customer\'s saved hotel stay so the two stay in sync. Rejects a number already used on another booking. Requires a service-principal JWT.
     */
    async v2InternalReservationsConfirmationPostRaw(requestParameters: V2InternalReservationsConfirmationPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<EditConfirmationResponse>> {
        if (requestParameters['editConfirmationRequest'] == null) {
            throw new runtime.RequiredError(
                'editConfirmationRequest',
                'Required parameter "editConfirmationRequest" was null or undefined when calling v2InternalReservationsConfirmationPost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("common_auth", []);
        }


        let urlPath = `/v2/internal/reservations/confirmation`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: EditConfirmationRequestToJSON(requestParameters['editConfirmationRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => EditConfirmationResponseFromJSON(jsonValue));
    }

    /**
     * Edit the confirmation (provider booking) number on a reservation, by its numeric booking_id, and re-push it to the customer\'s saved hotel stay so the two stay in sync. Rejects a number already used on another booking. Requires a service-principal JWT.
     */
    async v2InternalReservationsConfirmationPost(requestParameters: V2InternalReservationsConfirmationPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<EditConfirmationResponse> {
        const response = await this.v2InternalReservationsConfirmationPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * List upcoming Gondola Cash reservations which need a credit card authorization form, including both outstanding and submitted rows for the support checklist. Covers only the supplier paths that bill Gondola\'s own card (DIRECT_MANUAL, DIRECT_AUTOMATIC, TRAVELPORT); excludes cancelled/failed/fraud and test bookings, anything checking in outside the lookahead window. Ordered by check-in date, soonest first. Requires a service-principal JWT.
     */
    async v2InternalReservationsCreditCardAuthQueueGetRaw(requestParameters: V2InternalReservationsCreditCardAuthQueueGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreditCardAuthQueueResponse>> {
        const queryParameters: any = {};

        if (requestParameters['daysAhead'] != null) {
            queryParameters['days_ahead'] = requestParameters['daysAhead'];
        }

        if (requestParameters['includeSubmitted'] != null) {
            queryParameters['include_submitted'] = requestParameters['includeSubmitted'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("common_auth", []);
        }


        let urlPath = `/v2/internal/reservations/credit_card_auth_queue`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CreditCardAuthQueueResponseFromJSON(jsonValue));
    }

    /**
     * List upcoming Gondola Cash reservations which need a credit card authorization form, including both outstanding and submitted rows for the support checklist. Covers only the supplier paths that bill Gondola\'s own card (DIRECT_MANUAL, DIRECT_AUTOMATIC, TRAVELPORT); excludes cancelled/failed/fraud and test bookings, anything checking in outside the lookahead window. Ordered by check-in date, soonest first. Requires a service-principal JWT.
     */
    async v2InternalReservationsCreditCardAuthQueueGet(requestParameters: V2InternalReservationsCreditCardAuthQueueGetRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreditCardAuthQueueResponse> {
        const response = await this.v2InternalReservationsCreditCardAuthQueueGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Set or clear `bookings.credit_card_auth_requested`, recording whether the authorization was requested from the property. Idempotent and compare-and-set safe when clearing. Requires a service-principal JWT.
     */
    async v2InternalReservationsCreditCardAuthRequestedPostRaw(requestParameters: V2InternalReservationsCreditCardAuthRequestedPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreditCardAuthRequestedResponse>> {
        if (requestParameters['creditCardAuthRequestedRequest'] == null) {
            throw new runtime.RequiredError(
                'creditCardAuthRequestedRequest',
                'Required parameter "creditCardAuthRequestedRequest" was null or undefined when calling v2InternalReservationsCreditCardAuthRequestedPost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("common_auth", []);
        }


        let urlPath = `/v2/internal/reservations/credit_card_auth_requested`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreditCardAuthRequestedRequestToJSON(requestParameters['creditCardAuthRequestedRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CreditCardAuthRequestedResponseFromJSON(jsonValue));
    }

    /**
     * Set or clear `bookings.credit_card_auth_requested`, recording whether the authorization was requested from the property. Idempotent and compare-and-set safe when clearing. Requires a service-principal JWT.
     */
    async v2InternalReservationsCreditCardAuthRequestedPost(requestParameters: V2InternalReservationsCreditCardAuthRequestedPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreditCardAuthRequestedResponse> {
        const response = await this.v2InternalReservationsCreditCardAuthRequestedPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Set or clear `bookings.credit_card_auth_submitted`, recording whether the credit card authorization form for this reservation was submitted to the property. Idempotent: re-stamping an already-stamped reservation leaves the original timestamp untouched and returns it. Requires a service-principal JWT.
     */
    async v2InternalReservationsCreditCardAuthSubmittedPostRaw(requestParameters: V2InternalReservationsCreditCardAuthSubmittedPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreditCardAuthSubmittedResponse>> {
        if (requestParameters['creditCardAuthSubmittedRequest'] == null) {
            throw new runtime.RequiredError(
                'creditCardAuthSubmittedRequest',
                'Required parameter "creditCardAuthSubmittedRequest" was null or undefined when calling v2InternalReservationsCreditCardAuthSubmittedPost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("common_auth", []);
        }


        let urlPath = `/v2/internal/reservations/credit_card_auth_submitted`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreditCardAuthSubmittedRequestToJSON(requestParameters['creditCardAuthSubmittedRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CreditCardAuthSubmittedResponseFromJSON(jsonValue));
    }

    /**
     * Set or clear `bookings.credit_card_auth_submitted`, recording whether the credit card authorization form for this reservation was submitted to the property. Idempotent: re-stamping an already-stamped reservation leaves the original timestamp untouched and returns it. Requires a service-principal JWT.
     */
    async v2InternalReservationsCreditCardAuthSubmittedPost(requestParameters: V2InternalReservationsCreditCardAuthSubmittedPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreditCardAuthSubmittedResponse> {
        const response = await this.v2InternalReservationsCreditCardAuthSubmittedPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Set (or clear) the free-text operator notes on a reservation, by its numeric booking_id. Notes are editable in any status (e.g. a processed reservation left open for a while). Requires a service-principal JWT.
     */
    async v2InternalReservationsNotesPostRaw(requestParameters: V2InternalReservationsNotesPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SetReservationNotesResponse>> {
        if (requestParameters['setReservationNotesRequest'] == null) {
            throw new runtime.RequiredError(
                'setReservationNotesRequest',
                'Required parameter "setReservationNotesRequest" was null or undefined when calling v2InternalReservationsNotesPost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("common_auth", []);
        }


        let urlPath = `/v2/internal/reservations/notes`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SetReservationNotesRequestToJSON(requestParameters['setReservationNotesRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SetReservationNotesResponseFromJSON(jsonValue));
    }

    /**
     * Set (or clear) the free-text operator notes on a reservation, by its numeric booking_id. Notes are editable in any status (e.g. a processed reservation left open for a while). Requires a service-principal JWT.
     */
    async v2InternalReservationsNotesPost(requestParameters: V2InternalReservationsNotesPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SetReservationNotesResponse> {
        const response = await this.v2InternalReservationsNotesPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Resolve a reservation by its numeric booking_id to the handful of fields the support portal needs that the ordinary GET /booking response does not expose: the owner user_id (so api_support can impersonate the owner for the existing GET/PUT/DELETE booking routes), the payment_id (the client-side card-reveal handle — never a tokenized alias), and status / booking_process. Full reservation detail still comes from GET /booking. Requires a service-principal JWT.
     */
    async v2InternalReservationsResolvePostRaw(requestParameters: V2InternalReservationsResolvePostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResolveReservationResponse>> {
        if (requestParameters['resolveReservationRequest'] == null) {
            throw new runtime.RequiredError(
                'resolveReservationRequest',
                'Required parameter "resolveReservationRequest" was null or undefined when calling v2InternalReservationsResolvePost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("common_auth", []);
        }


        let urlPath = `/v2/internal/reservations/resolve`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ResolveReservationRequestToJSON(requestParameters['resolveReservationRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResolveReservationResponseFromJSON(jsonValue));
    }

    /**
     * Resolve a reservation by its numeric booking_id to the handful of fields the support portal needs that the ordinary GET /booking response does not expose: the owner user_id (so api_support can impersonate the owner for the existing GET/PUT/DELETE booking routes), the payment_id (the client-side card-reveal handle — never a tokenized alias), and status / booking_process. Full reservation detail still comes from GET /booking. Requires a service-principal JWT.
     */
    async v2InternalReservationsResolvePost(requestParameters: V2InternalReservationsResolvePostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResolveReservationResponse> {
        const response = await this.v2InternalReservationsResolvePostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * List unprocessed DIRECT_MANUAL reservations awaiting manual fulfillment — the support operator\'s to-do queue. Excludes test bookings, in-flight auto-save/boost re-bookings, and points bookings (the same selector the stale-booking alerter uses). Requires a service-principal JWT.
     */
    async v2InternalReservationsUnprocessedGetRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UnprocessedReservationsResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("common_auth", []);
        }


        let urlPath = `/v2/internal/reservations/unprocessed`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UnprocessedReservationsResponseFromJSON(jsonValue));
    }

    /**
     * List unprocessed DIRECT_MANUAL reservations awaiting manual fulfillment — the support operator\'s to-do queue. Excludes test bookings, in-flight auto-save/boost re-bookings, and points bookings (the same selector the stale-booking alerter uses). Requires a service-principal JWT.
     */
    async v2InternalReservationsUnprocessedGet(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UnprocessedReservationsResponse> {
        const response = await this.v2InternalReservationsUnprocessedGetRaw(initOverrides);
        return await response.value();
    }

    /**
     * Idempotently purge all favorite hotels for a deleting user. Requires the api_email_parser service principal.
     */
    async v2InternalUsersUserIdFavoriteHotelsDeleteRaw(requestParameters: V2InternalUsersUserIdFavoriteHotelsDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FavoriteHotelPurgeResponse>> {
        if (requestParameters['userId'] == null) {
            throw new runtime.RequiredError(
                'userId',
                'Required parameter "userId" was null or undefined when calling v2InternalUsersUserIdFavoriteHotelsDelete().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("common_auth", []);
        }


        let urlPath = `/v2/internal/users/{user_id}/favorite-hotels`;
        urlPath = urlPath.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters['userId'])));

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FavoriteHotelPurgeResponseFromJSON(jsonValue));
    }

    /**
     * Idempotently purge all favorite hotels for a deleting user. Requires the api_email_parser service principal.
     */
    async v2InternalUsersUserIdFavoriteHotelsDelete(requestParameters: V2InternalUsersUserIdFavoriteHotelsDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FavoriteHotelPurgeResponse> {
        const response = await this.v2InternalUsersUserIdFavoriteHotelsDeleteRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
